<!--
 * @Author: your name
 * @Date: 2022-03-08 13:42:03
 * @LastEditTime: 2023-04-24 20:27:34
 * @LastEditors: shijian.chen shijian.chen@qunar.com
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /dmf_ad_currency_h5/src/views/modules/changma202204/index.vue
-->
<template>
  <div id="main" class="NotoSansCJKscRegular">
    <div :class="'appoint '+(type=='test'?'test':'')">
      <div class="banner"></div>
      <lineComp v-if="type!='test'"></lineComp>
      <img v-if="type=='test'" src="https://source.qunarzz.com/site/images/wns/20230423-shijianchen-gy-tit1.png" class="tit1" alt="">
      <lineComp2 v-if="type=='test'"></lineComp2>
      <!-- <div @click="ruleDialog" class="ruleBtn"></div> -->
      <img
        src="https://source.qunarzz.com/site/images/wns/20230413-shijianchen-box4.png"
        alt=""
      />
      <img
        class="box2"
        src="https://source.qunarzz.com/site/images/wns/20230414-shijianchen-btm1.png"
        alt=""
      />
    </div>
  </div>
</template>
<script>
import banner from './components/banner.vue';
import appoint from './components/appoint.vue';
import videoComp from './components/video.vue';
import gotomini2 from './components/gotomini2.vue';
import lineComp from './components/line.vue';
import lineComp2 from './components/line2.vue';
import ruleDialog from './components/dialog/rule/index';
export default {
  components: {
    banner,
    appoint,
    videoComp,
    gotomini2,
    lineComp,
    lineComp2
  },
  data() {
    let type = '';
    if(this.$route.query.type){
      type = 'test'
    }
    if(+new Date()>+new Date('2023/04/24 21:00:00')){
      type = 'test'
    }
    console.log(this.$route.query.type,type)
    return {
      type,
      imgList2: [
        {
          w: 1136,
          h: 691,
          src: 'https://s.qunarzz.com/srmweb/qunaradv/changma202203/lines2/1.png',
          msrc: 'https://s.qunarzz.com/srmweb/qunaradv/changma202203/lines2/1.png',
        },
        {
          w: 1141,
          h: 695,
          src: 'https://s.qunarzz.com/srmweb/qunaradv/changma202203/lines2/2.png',
          msrc: 'https://s.qunarzz.com/srmweb/qunaradv/changma202203/lines2/2.png',
        },
        {
          w: 1139,
          h: 695,
          src: 'https://s.qunarzz.com/srmweb/qunaradv/changma202203/lines2/3.png',
          msrc: 'https://s.qunarzz.com/srmweb/qunaradv/changma202203/lines2/3.png',
        },
        {
          w: 1142,
          h: 697,
          src: 'https://s.qunarzz.com/srmweb/qunaradv/changma202203/lines2/4.png',
          msrc: 'https://s.qunarzz.com/srmweb/qunaradv/changma202203/lines2/4.png',
        },
        {
          w: 1141,
          h: 696,
          src: 'https://s.qunarzz.com/srmweb/qunaradv/changma202203/lines2/5.png',
          msrc: 'https://s.qunarzz.com/srmweb/qunaradv/changma202203/lines2/5.png',
        },
        {
          w: 1141,
          h: 696,
          src: 'https://s.qunarzz.com/srmweb/qunaradv/changma202203/lines2/6.png',
          msrc: 'https://s.qunarzz.com/srmweb/qunaradv/changma202203/lines2/6.png',
        },
      ],
    };
  },
  methods: {
    ruleDialog,
    showThumbsList(index) {
      this.$refs.previewer.show(index);
    },
  },
  mounted() {},
};
</script>
<style lang='less' scoped='true'>
.banner{
  height: 679px;
}
.appoint {
  background: url(https://source.qunarzz.com/site/images/wns/20230413-shijianchen-yao-1.jpg)
    no-repeat;
  background-size: 100% auto;
  // height: 3514px;
  height: 2968px;
  box-sizing: border-box;
  overflow: hidden;
  position: relative;
}
.appoint.test{
  height: 2281px;
  background-image: url(https://source.qunarzz.com/site/images/wns/20230424-shijianchen-bg-0078.jpg);
  .banner{
    height:556px;
  }
}
.card {
  display: block;
}
.tit1{
  width:372px;
  position: relative;
  left:30px;
  top: 20px;
  z-index:10;
}
.box2 {
  position: relative;
  top: 30px;
}
.videoBox {
  background: url(https://source.qunarzz.com/site/images/wns/20220620-shijianchen-changma-3.jpg)
    no-repeat;
  background-size: 100% auto;
  height: 824px;
  box-sizing: border-box;
  padding-top: 109px;
}
.miniBox {
  background: url(https://source.qunarzz.com/site/images/wns/20220620-shijianchen-changma-4.jpg)
    no-repeat;
  background-size: 100% auto;
  height: 861px;
  box-sizing: border-box;
  padding-top: 150px;
  position: relative;
  &:before {
    content: '';
    display: block;
    background: url(https://source.qunarzz.com/site/images/wns/20220620-shijianchen-changma-5.jpg)
      no-repeat;
    background-size: 100% auto;
    background-position-y: bottom;
    position: absolute;
    bottom: 0;
    height: 300px;
    width: 100%;
  }
}
.ruleBtn {
  position: absolute;
  right: 0;
  top: 624px;
  width: 81px;
  height: 28px;
}
.videoComp1 {
  width: 323px;
  margin: 0 auto;
  margin-bottom: 22px;
}
.gotomini2 {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  z-index: 10;
}
.miniclip {
  position: relative;
  height: 860px;
  overflow-y: hidden;
}
.showBox {
  position: relative;
  z-index: 2;
  height: 510px;
  // background: url(https://s.qunarzz.com/srmweb/qunaradv/changma202201/10.png)
  //   no-repeat;
  // background-size: 100% auto;
  overflow-y: hidden;
}
.lastBox {
  background: url(https://s.qunarzz.com/srmweb/qunaradv/changma202203/25.jpg)
    no-repeat;
  background-size: 100% auto;
  height: 782px;
  padding-top: 74px;
  box-sizing: border-box;
}
.boxBtm {
  position: absolute;
  z-index: 9;
}
.boxBtm1 {
  width: 107px;
  height: 216px;
  left: 25px;
  top: 0;
}
.disabledFn {
  position: relative;
  top: -26px;
}
.boxBtm2 {
  width: 220px;
  height: 108px;
  left: 132px;
  top: 0;
}
.boxBtm3 {
  width: 110px;
  height: 108px;
  left: 132px;
  top: 108px;
}
.boxBtm4 {
  width: 110px;
  height: 108px;
  left: 242px;
  top: 108px;
}
.boxBtm5 {
  width: 107px;
  height: 108px;
  left: 25px;
  top: 219px;
}
.boxBtm6 {
  width: 220px;
  height: 108px;
  left: 132px;
  top: 219px;
}
.showTit {
  position: absolute;
  bottom: 52px;
  width: 320px;
  left: 50%;
  margin-left: -160px;
}
.button {
  position: absolute;
  width: 163px;
  height: 39px;
  left: 50%;
  transform: translateX(-50%);
  bottom: 121px;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    width: 100%;
  }
}
.sanya {
  height: 172px;
  display: block;
}
.chuanxi {
  height: 168px;
  display: block;
}
</style>